import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["checked", "defaultChecked", "onChange"];
import { forwardRef } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { useChecked } from '../../utils/useChecked/useChecked';
import { attachWrappedComponent } from '../../utils/decoratorUtils/decoratorUtils';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Similar to `Controllable`, but specifically for controlling a `checked` property using the same
 * API as native checkbox inputs: `checked`, `defaultChecked`, and `onChange`. Additionally,
 * the events passed to `onChange` use `evt.target.checked` instead of `evt.target.value`.
 *
 * This should not be used with radio inputs, as their `checked` state is dependant on the
 * others inputs in the group (see UIComponents#9441).
 *
 * @param Component
 * @returns A component with defaultable `checked` prop
 */
export function Checkable(Component) {
  const CheckableComponent = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
        checked: checkedProp,
        defaultChecked: defaultCheckedProp = false,
        onChange: onChangeProp
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    const {
      checked,
      onChange
    } = useChecked({
      checked: checkedProp,
      defaultChecked: defaultCheckedProp,
      onChange: onChangeProp
    });
    return (
      /*#__PURE__*/
      // @ts-ignore - 'T' could be instantiated with a different subtype of constraint 'CheckedProps'
      _jsx(Component, Object.assign({}, rest, {
        checked: checked,
        onChange: onChange,
        ref: ref
      }))
    );
  });
  CheckableComponent.displayName = `Checkable(${getComponentName(Component)})`;
  attachWrappedComponent(CheckableComponent, Component);
  return CheckableComponent;
}